import {
  ArrowLeftRight,
  Bell,
  Binoculars,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarX,
  CircleCheck,
  CircleX,
  Clock,
  ContactRound,
  CreditCard,
  Crown,
  DoorOpen,
  FlagTriangleLeft,
  Gavel,
  GraduationCap,
  Hand,
  Inbox,
  Link2,
  Megaphone,
  MessageSquare,
  MessageSquareReply,
  PlayCircle,
  Reply,
  ScrollText,
  ShieldAlert,
  Sparkles,
  Trophy,
  Undo2,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserRoundX,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

// Keyed by string: the API sends kinds newer than the shared NotificationType union.
const typeIcons: Record<string, LucideIcon> = {
  match_scheduled: Calendar,
  match_rescheduled: CalendarClock,
  match_cancelled: CalendarX,
  match_result: Trophy,
  team_invite: UserPlus,
  roster_player_added: UserPlus,
  roster_player_removed: UserMinus,
  season_registration_open: PlayCircle,
  season_closing_soon: Clock,
  season_started: FlagTriangleLeft,
  season_ended: FlagTriangleLeft,
  org_announcement: Megaphone,
  league_rule_update: ScrollText,
  payment_reminder: CreditCard,
  eligibility_change: GraduationCap,
  scouting_interest: Binoculars,
  org_invite: UserPlus,
  org_member_joined: UserPlus,
  guest_team_claimable: UserCheck,
  guest_team_ownable: Crown,
  guest_team_owner_requested: Hand,
  guest_team_owner_decided: Crown,
  team_contact_primary: ContactRound,
  team_contact_changed: ContactRound,
  team_contact_lost: UserRoundX,
  team_contact_event: ContactRound,
  team_contact_event_changed: ContactRound,
  team_contact_method_requested: ContactRound,
  team_contact_message: MessageSquare,
  team_contact_league_request: ContactRound,
  competition_entry_received: Inbox,
  competition_entry_approved: CircleCheck,
  competition_entry_rejected: CircleX,
  competition_entry_withdrawn: Undo2,
  competition_entry_leave_requested: DoorOpen,
  competition_ruling: Gavel,
  match_sides: ArrowLeftRight,
  side_swap_request: ArrowLeftRight,
  riot_link_request: Link2,
  league_roster_change: UserPlus,
  free_agent_request_received: UserPlus,
  free_agent_admitted: UserCheck,
  free_agent_rejected: UserRoundX,
  free_agent_recommended: Sparkles,
  free_agent_recommendation_answered: MessageSquareReply,
  competition_rules_published: ScrollText,
  schedule_announcement: CalendarDays,
  org_role_changed: UserCog,
  team_role_changed: UserCog,
  roster_flag: ShieldAlert,
  team_invite_response: Reply,
}

/** The icon for a kind of notification; a bell for kinds this map doesn't know yet. */
export function notificationTypeIcon(type: string): LucideIcon {
  return typeIcons[type] ?? Bell
}
